import React from 'react';
import useFlatData from '../../../Base/Hooks/useFlatData';
import useInsuranceReports from '../../Hooks/useInsuranceReports';
// @ts-ignore
import styles from './InsuranceReportsList.module.scss';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
import InsuranceReportsListItem from './InsuranceReportsListItem';

interface Props {
	patientId: string;
}

const wrapperId = 'insuranceReportsListWrapper';

const InsuranceReportsList: React.FC<Props> = ({ patientId }) => {
	const {
		getFlatInsuranceReports,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	} = useInsuranceReports();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatInsuranceReports,
		{
			data: data?.insuranceReports?.data,
			totalPages: data?.insuranceReports?.meta?.totalPages,
			page: data?.insuranceReports?.meta?.page,
		},
		page,
		setPage,
		{
			patientId,
		},
	);

	return (
		<div className={styles.wrapper}>
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={item => (
						<InsuranceReportsListItem item={item} onDelete={loadData} />
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default InsuranceReportsList;
